exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.company-badge[data-v-4f5a4a9a] {\n  display: inline-block;\n  padding: 6px 12px;\n  border-radius: 4px;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 13px;\n  letter-spacing: 0.5px;\n}\n.bg-navy[data-v-4f5a4a9a] {\n  background-color: #001f3f !important;\n}\n.margin-top[data-v-4f5a4a9a] {\n  margin-top: 15px;\n}\n.p-3[data-v-4f5a4a9a] {\n  padding: 15px;\n}\n", ""]);

// exports
